<template>
  <div
    v-if="isFiltered"
    class="store-active-filters"
  >
    <div>{{ resultsLabel }}</div>

    <button
      type="button"
      class="btn btn--small"
      @click="clearFilters"
    >
      Clear Filters
    </button>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'

export default {
  name: 'ActiveFilters',

  computed: {
    ...mapState([
      'results',
      'currentFilters',
      'searchTerm',
      'isLoading'
    ]),

    resultsLabel() {
      const label = this.results.length === 1 ? 'result' : 'results'

      return `Showing ${this.results.length} ${label}`
    },

    isFiltered() {
      return !this.isLoading && (this.currentFilters.length || this.searchTerm)
    }
  },

  methods: {
    ...mapMutations([
      'clearFilters'
    ])
  }
}
</script>
